import React, { useState } from 'react';
import '../../../styles/resume-editor.css';

interface LayoutSelectorProps {
  currentLayout: 'inline' | 'stacked';
  onBack: () => void;
  onSelect: (layout: 'inline' | 'stacked') => void;
}

export const LayoutSelector: React.FC<LayoutSelectorProps> = ({
  currentLayout,
  onBack,
  onSelect,
}) => {
  const [selectedLayout, setSelectedLayout] = useState<'inline' | 'stacked'>(currentLayout);

  const handleSave = () => {
    if (selectedLayout !== currentLayout) {
      onSelect(selectedLayout);
    }
    onBack();
  };

  return (
    <div className="resume-editor__section-expanded-body">
      <div className="add-section__layout-header">
        <h3 className="add-section__layout-title">Choose Layout</h3>
        <p className="add-section__layout-subtitle">Defines how your section entries are displayed.</p>
      </div>

      <div className="add-section__layout-options">
        <div
          className={`add-section__layout-card ${selectedLayout === 'inline' ? 'add-section__layout-card--selected' : ''}`}
          onClick={() => setSelectedLayout('inline')}
        >
          <div className="add-section__layout-content">
            <h4 className="add-section__layout-name">Inline</h4>
            <p className="add-section__layout-description">
              Ideal for simple lists or detailed entries where you need a compact, space-saving layout.
            </p>
            <div className="add-section__layout-suggested">
              <span className="add-section__layout-suggested-label">Suggested for</span>
              <div className="add-section__layout-tags">
                <span className="add-section__layout-tag">Hobbies</span>
                <span className="add-section__layout-tag">Key Achievements</span>
                <span className="add-section__layout-tag">References</span>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`add-section__layout-card ${selectedLayout === 'stacked' ? 'add-section__layout-card--selected' : ''}`}
          onClick={() => setSelectedLayout('stacked')}
        >
          <div className="add-section__layout-content">
            <h4 className="add-section__layout-name">Stacked</h4>
            <p className="add-section__layout-description">
              Ideal for an expansive, detailed layout, giving each entry its own block to showcase more complex information (title, date, descriptions).
            </p>
            <div className="add-section__layout-suggested">
              <span className="add-section__layout-suggested-label">Suggested for</span>
              <div className="add-section__layout-tags">
                <span className="add-section__layout-tag">Publications</span>
                <span className="add-section__layout-tag">Awards</span>
                <span className="add-section__layout-tag">Other Experience</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="add-section__footer">
        <button
          type="button"
          className="add-section__btn add-section__btn--cancel"
          onClick={onBack}
        >
          Back
        </button>
        <button
          type="button"
          className="add-section__btn add-section__btn--create"
          onClick={handleSave}
        >
          Save
        </button>
      </div>
    </div>
  );
};

